module.exports = __webpack_public_path__ + "img/linkedin-icon.75d77189.svg";